<template>
  <div class="banatDeutsche">
    <h1>Deutsche Minderheit im Banat</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/ferd_1kl.jpg" width="125" height="110" border="0" alt="Ferdinandsberg / Oţelu Roşu: evangelische Kirche, gebaut von einem Karlsruher"
        @click="callImageClick('Ferdinandsberg / Oţelu Roşu: evangelische Kirche, gebaut von einem Karlsruher', 'ferd_1.jpg', $event)">
        <br>Ferdinandsberg / Oţelu Roşu: evangelische Kirche, gebaut von einem Karlsruher
      </div>
      <div class="foto">
        <img src="../assets/fotos/ferd_2kl.jpg" width="125" border="0" height="110" alt="Ferdinandsberg / Oţelu Roşu: evangelische Kirche"
        @click="callImageClick('Ferdinandsberg / Oţelu Roşu: evangelische Kirche', 'ferd_2.jpg', $event)">
        <br>Ferdinandsberg / Oţelu Roşu: evangelische Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/Ferdinand_Gedenktafel_kl.jpg" width="125" border="0" height="110" alt="Ferdinandsberg / Oţelu Roşu: evangelische Kirche"
        @click="callImageClick('Ferdinandsberg / Oţelu Roşu: evangelische Kirche', 'Ferdinand_Gedenktafel.jpg', $event)">
        <br>Ferdinandsberg / Oţelu Roşu: evangelische Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/ferd_3kl.jpg" width="125" height="110" border="0" alt="Ferdinandsberg / Oţelu Roşu: evangelische Kirche, Altar aus Gußeisen"
        @click="callImageClick('Ferdinandsberg / Oţelu Roşu: evangelische Kirche, altar aus Gußeisen', 'ferd_3.jpg', $event)">
        <br>Ferdinandsberg / Oţelu Roşu: evangelische Kirche, Altar aus Gußeisen
      </div>
      <div class="foto">
        <img src="../assets/fotos/resc_6kl.jpg" width="125" border="0" height="110" alt="Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945"
        @click="callImageClick('Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945', 'resc_6.jpg', $event)">
        <br>Reschitza, Reşiţa: Denkmal der Deportation der Banater Berglanddeutschen nach Rußland 1945
      </div>
      <div class="foto">
        <img src="../assets/fotos/orav_3kl.jpg" width="125" border="0" height="110" alt="Bahnhof Oraviţa / Oravitza: 
        Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951"
        @click="callImageClick('Bahnhof Oraviţa / Oravitza:  Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951', 
        'orav_3.jpg', $event)">
				<br>Bahnhof Oraviţa / Oravitza: Erinnerung an die Deportation aus dem Banat ins Baragan am schwarzen Pfingsten 1951
        <br>Im Jahre 1951 wurden viele Banater entlang der Grenze zu Serbien  
        in die Steppe des Baragan deportiert. Für die Deutschen im Banat war 
        dies die zweite verlustreiche Deportation innerhalb weniger Jahre.
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>